<template>
    <div>
       <div class="row row-spacing mb-2">
        <div class="col-md-12">
            <button class="btn btn-info" @click="addPackage()">
                Add New Package
            </button>
        </div>
       </div>
       <div class="row row-spacing mb-2">
        <div class="col-md-12">
            <div class="table-responsive table-bordered" v-if="additionalPackages.length > 0">
                <table class="table">
                    <thead>
                        <tr class="text-nowrap">
                            <th>Additional Billing Type</th>
                            <th>Description</th>                            
                            <th>Price</th>
                            <th class="pricing-status-column">Expired</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody 
                        v-for="additional in additionalPackages"
                        :key="additional.objKey"
                        :class="{ 'bg-primary': additional.expired }"
                    >
                        <tr>
                            <td class="text-nowrap text-left">{{ additional.additionalBilling }}</td>
                            <td class="pricing-label-column">{{ additional.label }}</td>
                            <td class="text-nowrap">{{ decimalFormat(additional.priceExclVat) }}</td>
                            <td class="text-nowrap text-center">
                                <span class="badge" :class="additional.expired ? 'badge-warning' : 'badge-green'">
                                    {{ additional.expired }}
                                </span>
                            </td>
                            <td class="text-center">
                                <button
                                    v-if="userEditRight"                  
                                    v-tooltip="'Edit Package'"
                                    @click="editPackage(additional)"
                                    type="button"
                                    class="btn btn-sm btn-info m-1"
                                >
                                    <em class="fa fa-edit fa-fw"></em>
                                </button>
                                <button
                                    v-if="userEditRight"                  
                                    v-tooltip="'Delete Package'"
                                    type="button"
                                    @click="deletePackage(additional)"
                                    class="btn btn-sm btn-primary"
                                >
                                    <em class="fa fa-trash fa-fw"></em>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else class="alert alert-info">No Additional Packages Available</div>
        </div>
       </div>
       <ModifyAdditionalPackageModal 
        ref="modifyAdditionalPackageModal"
        :additionalPackage="additionalPackage"
        :additionalBillingTypes="additionalBillingTypes"
        :modalTitle="modalTitle"
        @createAdditionalPackage="createAdditionalPackage"
        @updateAdditionalPackage="updateAdditionalPackage"
       />
    </div>
</template>

<script>
import PriceFunctions from "@/components/Admin/PriceFunctions";
import ModifyAdditionalPackageModal from "@/components/Admin/Modals/ModifyAdditionalPackageModal.vue";

export default {
    extends: PriceFunctions,
    components: {
        ModifyAdditionalPackageModal
    },
    props: {
        productNumber: {
            type: Number,
            required: true,
        },
        userEditRight: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            additionalPackages: [],
            additionalPackage: {},
            period: this.getCurrentPeriod(),
            rowPrice: [],
            newPrice: {},
            additionalBillingTypes: [],
            modalTitle: "",
        }
    },
    mounted() {
        this.getAdditionalPackages();
        this.getAdditionalBillingTypes();
    },
    methods: {
        getAdditionalPackages: function() {
            const hostUrl = this.$config.aimsAPI;
            this.$http.get(`${hostUrl}pricing/additionalpackages/${this.productNumber}`).then(
                (response) => {
                    this.additionalPackages = response.data;
                },
                (error) => {
                    console.error(error);
                    this.showError("Error fetching Additional Packages", error);
                }
            );
        },
        getEmptyPackage: function() {
            const hostUrl = this.$config.aimsAPI;
            this.$http.get(`${hostUrl}pricing/additionalpackages/empty`).then(
                (response) => {
                    this.additionalPackage = response.data;   
                },
                (error) => {
                    console.error(error);
                    this.showError("Error fetching empty Additional Package", error);
                }
            );
        },
        getAdditionalBillingTypes: function() {
            const hostUrl = this.$config.aimsAPI;
            this.$http.get(`${hostUrl}pricing/additionalpackages/additionalbillingtypes`).then(
                (response) => {
                    this.additionalBillingTypes = response.data;                
                },
                (error) => {
                    console.error(error);
                    this.showError("Error fetching Additional Billing Types", error);
                }
            );
        },
        addPackage: function() {
            this.modalTitle = "Add Additional Billing Package";
            this.getEmptyPackage();
            this.$refs.modifyAdditionalPackageModal.open();
        },
        createAdditionalPackage: function(pkg) {
            //set required productNumber
            pkg.productNumber = this.productNumber;
            const hostUrl = this.$config.aimsAPI;
            this.$http.post(`${hostUrl}pricing/additionalpackages`, pkg).then(
                () => {
                    this.showSuccess("Package Created");  
                    this.getAdditionalPackages();
                },
                (error) => {
                    console.error(error);
                    this.showError("Error creating Additional Package", error);
                }
            );
        },
        editPackage: function(pkg) {
            this.modalTitle = "Update Additional Package";
            this.additionalPackage = this.deepCopyObject(pkg);
            this.$refs.modifyAdditionalPackageModal.open();
        },
        updateAdditionalPackage: function(pkg) {
            const hostUrl = this.$config.aimsAPI;
            this.$http.put(`${hostUrl}pricing/additionalpackages`, pkg).then(
                () => {
                    this.showSuccess("Package Saved");  
                    this.getAdditionalPackages();
                },
                (error) => {
                    console.error(error);
                    this.showError("Error updating Additional Package", error);
                }
            );
        },
        deletePackage: function(pkg) {
            this.$swal({
                title: "Are you sure you want to delete this Package?",
                type: "warning",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes",
            }).then((result) => {
                if (result.value) {
                    const hostUrl = this.$config.aimsAPI;
                    this.$http.delete(`${hostUrl}pricing/additionalpackages/${pkg.objKey}`).then(
                        () => {    
                            this.showSuccess("Additional package deleted");
                            this.getAdditionalPackages();
                        },
                        (error) => {
                            this.showError("Error deleting Additional Package", error);
                        }
                    );
                }
            });
        },
        decimalFormat(value) {
            if (value > 0) {
            return "R " + parseFloat(value).toFixed(2);
            } else {
            return "-";
            }
        },
    }
}
</script>

<style scoped>
.filter-container {
  position: relative;
  z-index: 999;
}

.filter-container .filter-wrapper {
  position: absolute;
  z-index: 999;
  margin-top: .5em;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  padding: 2px;
  width: 350px;
  right: 90;
  top: -42;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

.filter-container .filter-wrapper .filter-body {
  max-height: 200px;
  overflow: scroll;
  overflow-x: hidden;
  padding: 10px;
  text-align: left;
}

th.table-font-size {
  font-size: .95rem;
}
th.table-header-width-1 {
  width: 10px;
}
th.table-header-width-2 {
  width: 20px;
}
th.table-header-width-3 {
  width: 50px;
}
th.table-header-width-4 {
  width: 60px;
}
th.table-header-width-5 {
  width: 95px;
}
th.table-header-width-6 {
  width: 200px;
}

.font-size {
  font-size: .9rem;
}
</style>